import { AuditOrigin } from "../../http/protocol";
import { t } from "../../i18n";

const ORIGIN_LABELS: Record<AuditOrigin, { key: string; fallback: string }> = {
  [AuditOrigin.UI]: { key: "audit.origin.ui", fallback: "UI" },
  [AuditOrigin.AI_ASSISTANT]: { key: "audit.origin.ai-assistant", fallback: "AI assistant" },
  [AuditOrigin.AI_ASSISTED]: { key: "audit.origin.ai-assisted", fallback: "AI assisted" },
  [AuditOrigin.AI_AGENT_API]: { key: "audit.origin.ai-agent-api", fallback: "AI agent API" },
  [AuditOrigin.AI_MCP_CLIENT]: { key: "audit.origin.ai-mcp-client", fallback: "AI (MCP client)" },
};

// The generated protocol type marks origin optional; an absent value is a UI action.
function resolveOrigin(origin?: AuditOrigin): AuditOrigin {
  return origin ?? AuditOrigin.UI;
}

/** Returns the display label for an audit origin; a missing origin is labelled as UI. */
export function auditOriginLabel(origin?: AuditOrigin): string {
  const { key, fallback } = ORIGIN_LABELS[resolveOrigin(origin)];
  return t(key, undefined, fallback);
}

/** Returns true when the entry came through an AI channel; a missing origin counts as UI, so false. */
export function isAiOrigin(origin?: AuditOrigin): boolean {
  return resolveOrigin(origin) !== AuditOrigin.UI;
}
